function loadSupportedTimeZones(): Set<string> | null {
	if (typeof Intl.supportedValuesOf !== "function") return null
	return new Set(Intl.supportedValuesOf("timeZone"))
}

const supportedTimeZones = loadSupportedTimeZones()

function normalizeIanaTimezone(
	timezone: string | null | undefined,
): string | undefined {
	const value = timezone?.trim()
	if (!value) return undefined

	try {
		const resolved = Intl.DateTimeFormat(undefined, {
			timeZone: value,
		}).resolvedOptions().timeZone

		if (supportedTimeZones) {
			if (!supportedTimeZones.has(resolved)) return undefined
			return resolved
		}

		if (resolved === "UTC" || resolved.includes("/")) return resolved
		return undefined
	} catch {
		return undefined
	}
}

export function getDeviceTimezone(): string | undefined {
	try {
		return normalizeIanaTimezone(
			Intl.DateTimeFormat().resolvedOptions().timeZone,
		)
	} catch {
		return undefined
	}
}
